"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Link } from "@/components/common/Link";
const faqData = [{
  id: "item-1",
  question: "What types of vehicles are available?",
  answer: "We offer a premium fleet of luxury sedans and SUVs, all meticulously maintained to ensure your comfort and safety. Every vehicle is equipped with modern amenities and driven by professional chauffeurs."
}, {
  id: "item-2",
  question: "How do I book a ride?",
  answer: "Booking is simple—call or text us at 323-492-6292, or email phoenixenerprises@gmail.com with your pickup details, destination, and preferred vehicle type. We'll confirm your reservation promptly."
}, {
  id: "item-3",
  question: "Do you provide airport transfers?",
  answer: "Yes, we specialize in airport transfers throughout Los Angeles and surrounding areas. Our drivers monitor flight schedules to ensure timely pickups and drop-offs, so you never miss a beat."
}, {
  id: "item-4",
  question: "Are your services available 24/7?",
  answer: "Absolutely. PHOENIX ENTERPRISE TCP operates around the clock, 24/7, to accommodate your schedule—whether it's an early morning flight or a late-night event."
}, {
  id: "item-5",
  question: "What areas do you serve?",
  answer: "We serve Los Angeles and all surrounding areas in Southern California. If you need transportation beyond our standard service area, contact us to discuss custom arrangements."
}, {
  id: "item-6",
  question: "Can I book for special events?",
  answer: "Yes, we offer hourly and event bookings for weddings, corporate gatherings, VIP occasions, and more. Our chauffeurs provide discreet, professional service tailored to your event's needs."
}];
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  return <section id="frequently-asked-questions" className="dark bg-background text-foreground section-padding relative overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLXdpZHRoPSIxIi8+PC9wYXR0ZXJuPjwvZGVmcz48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ1cmwoI2dyaWQpIi8+PC9zdmc+')] bg-repeat" />

      <div className="container mx-auto px-4 relative z-10">
        <div ref={ref} className={`max-w-3xl mx-auto transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          {}
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-display font-bold mb-4 tracking-tight">
              Frequently Asked Questions
            </h2>
            <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
              Everything you need to know about our luxury chauffeur services.
              Can't find an answer? Contact us at{" "}
              <Link to="tel:323-492-6292" className="text-secondary hover:underline">
                323-492-6292
              </Link>
              .
            </p>
          </div>

          {}
          <div className="glass-effect p-6 md:p-8">
            <Accordion type="single" collapsible className="space-y-4">
              {faqData.map((item, i) => <AccordionItem key={item.id} value={item.id} data-index={i} className="glass-effect border-white/10 rounded-lg px-6 py-2 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:shadow-medium hover:bg-white/5">
                  <AccordionTrigger className="text-left text-base md:text-lg font-semibold text-dark-foreground hover:no-underline hover:text-secondary">
                    {item.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground leading-relaxed">
                    {item.answer}
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>
          </div>
        </div>
      </div>
    </section>;
}